import { useEffect, useState } from "react";

import { MIN_SEARCH_LENGTH, SEARCH_DEBOUNCE_MS } from "./accessoryFilters";

const queryable = (term) => String(term || "").trim().length >= MIN_SEARCH_LENGTH;

const useDebouncedTerm = (term, delay = SEARCH_DEBOUNCE_MS) => {
  const [settled, setSettled] = useState(term);

  useEffect(() => {
    if (!queryable(term)) {
      setSettled(term);

      return undefined;
    }

    const timer = setTimeout(() => setSettled(term), delay);

    return () => clearTimeout(timer);
  }, [term, delay]);

  return {
    term: settled,
    pending: queryable(term) && settled !== term,
  };
};

export default useDebouncedTerm;
